"use client";

import { cn, getAssetsUrl } from "utils";

import { I18nUtil } from "@utils/i18n";
import { PortfolioActionButton } from "../AiPortfolioCard/PortfolioActionButton";
import React from "react";
import Translations from "@translate/components/Portfolio/PortfolioGhostState/GhostActionCards";

const I18n = I18nUtil.createScoped(Translations);

/**
 * Portfolio Summary / Portfolio Check entry cards (visual only on ghost page).
 */
export const GhostActionCards: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        "pointer-events-none flex w-full gap-3 opacity-40",
        className,
      )}
      data-testid="portfolio-ghost-action-cards"
      aria-hidden
    >
      <PortfolioActionButton
        className="flex-1 max-md:min-h-[68px]"
        title={I18n.t("Portfolio Summary")}
        style={{
          "--icon-url": `url(${getAssetsUrl("/assets/images/portfolio/health_check.svg?v=2")})`,
        }}
        iconClassName="[background-image:var(--icon-url)]"
      />
      <PortfolioActionButton
        className="flex-1 max-md:min-h-[68px]"
        title={I18n.t("Portfolio Check")}
        style={{
          "--icon-url": `url(${getAssetsUrl("/assets/images/portfolio/happend.svg?v=2")})`,
        }}
        iconClassName="[background-image:var(--icon-url)]"
      />
    </div>
  );
};
